export const ADD_SUCCESS = 'Новый оператор ЭЗС добавлен';
export const ADD_ERROR = 'Не удалось добавить оператора ЭЗС';
